import { Link } from "react-router-dom";

const isExternal = (href = "") =>
  /^(?:https?:|mailto:|tel:)/i.test(href);

export default function ButtonLink({
  href,
  children,
  variant = "primary",
  size,
  className = "",
  ...props
}) {
  const classes = [
    "button-link",
    variant !== "primary" ? `button-link--${variant}` : "",
    size ? `button-link--${size}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (isExternal(href)) {
    return (
      <a
        className={classes}
        href={href}
        rel={href.startsWith("http") ? "noreferrer" : undefined}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link className={classes} to={href || "/"} {...props}>
      {children}
    </Link>
  );
}
